import styled from 'styled-components';

export const StyledIconContainer = styled.div`
    width: 120px;
    height: 120px;
`;
